import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'
import type { OptionalSelectionModifiers } from '@/atoms'

import { getCrudSelection, setCrudSelection, getMainSelection, setMainSelection } from '@/atoms'

import { getConnectedList } from '../../../../atoms/selection/read/getConnectedList'
import { getMapSelectionContext } from '../../../../atoms/selection/read/getMapSelectionContext'

export function clickVehicle(feature: Feature<Geometry>, modifiers: OptionalSelectionModifiers) {
  const connectedList = getConnectedList()
  const mapSelectionContext = getMapSelectionContext()

  const vehicleId = feature.getId()?.toString()

  if (vehicleId) {
    const selection = [vehicleId]

    // select
    if (mapSelectionContext.type === 'crud') {
      if (mapSelectionContext.category === 'unifiedVehicles') {
        const crudSelection = getCrudSelection()
        const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

        // If there's no modifier and the vehicle is already selected we must deselect it
        if (withoutModifiers) {
          const index = crudSelection.unifiedVehicles.indexOf(selection[0])

          if (index !== -1) {
            selection.splice(index, 1)

            setCrudSelection('unifiedVehicles', selection, { modifiers })
            return
          }
        }

        setCrudSelection('unifiedVehicles', selection, { modifiers })

        // try to scroll to
        if (
          connectedList.status === 'connected' &&
          connectedList.category === 'unifiedVehicles' &&
          !connectedList.disabled
        ) {
          connectedList.scrollTo(vehicleId)
        }
      }
    } else {
      const mainSelection = getMainSelection()
      const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

      // If there's no modifier and the vehicle is already selected we must deselect it
      if (withoutModifiers) {
        const index = mainSelection.unifiedVehicles.indexOf(selection[0])

        if (index !== -1) {
          selection.splice(index, 1)

          setMainSelection('unifiedVehicles', selection, { modifiers })
          return
        }
      }
      setMainSelection('unifiedVehicles', selection, { modifiers })
    }
  }
}
